<script setup lang="ts">
import { computed } from "vue";

import SelectableList from "@/components/ui/SelectableList/SelectableList.vue";
import type { Iteration } from "@/model/session";
import type { useActivityStore } from "@/store/activity";
import type { useSearchMenuStore } from "@/store/search/searchMenu";

import IterationItemTooltip from "../tooltips/IterationItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";

const props = defineProps<{
  store: ReturnType<typeof useSearchMenuStore> | ReturnType<typeof useActivityStore>;
}>();

const selection = computed({
  get: () => props.store.selectedIterations,
  set: (values: Iteration[]) => props.store.selectIterations(values),
});
</script>

<template>
  <SearchDropdown
    name="iteration"
    icon="general/iteration"
    label-key="general.iterations"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <IterationItemTooltip :iterations="selection" />
    </template>
    <SelectableList
      v-model="selection"
      v-keyboard-nav
      :values="store.allIterations"
      :header="$t('general.iterations')"
    >
      <template #default="{ item }">
        {{ $t("general.namedIteration", { name: item.name }) }}
      </template>
    </SelectableList>
  </SearchDropdown>
</template>
